import React, { useState } from 'react';

/**
 * Mobile collapse host for a page-level action row (CD-5409).
 *
 * Below 768px a page's .InnerMenuButtonFigmaList action row does not fit the 80px header band it is
 * position:fixed into, so this host hides it behind a "…" toggle fixed into the band's top-right and
 * reveals it as a dropdown menu — the same menu the CD-5241 detail popups use (shared look in
 * Style.css under the .page-actions-host/.page-actions-open pair; toggle + placement glue in
 * bravo-app.css). Above 768px the host is inert: the toggle is display:none and the child renders
 * exactly as it would unwrapped.
 *
 * FigmaButtonRow wraps itself in this automatically when given the InnerMenuButtonFigmaList class;
 * rows rendered another way (e.g. the legacy ButtonRow) can opt in by wrapping themselves the same
 * way. Inside detail popups (.top-of-boxFigma) the toggle stays hidden and OverWindow's own header
 * "…" drives the menu, so the host is safe to keep around the row there too.
 */
export default function PageActionsHost({ children }) {
  const [actionsOpen, setActionsOpen] = useState(false);

  return (
    <div
      className={`page-actions-host${actionsOpen ? ' page-actions-open' : ''}`}
      // Picking an action closes the menu. Capture-phase, so it must skip the toggle itself or it
      // would race the toggle's own click and re-open it. The instanceof check narrows EventTarget
      // to Element for the TS checker (this file is plain JS, but .tsx is still type-checked).
      onClickCapture={(e) => {
        if (actionsOpen && e.target instanceof Element && !e.target.closest('.page-actions-toggle')) {
          setActionsOpen(false);
        }
      }}
    >
      <button
        type='button'
        className='page-actions-toggle'
        title='Actions'
        onClick={() => setActionsOpen((open) => !open)}
      >
        <i className='fa-solid fa-ellipsis-vertical' />
      </button>
      {children}
    </div>
  );
}
